import React, { FC } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import Icon from '../IconDS22';
import s from './CaptainSnippet.module.scss';

export type Props = {
  captained?: boolean;
  classNameModifier?: string;
};

const CaptainIcon: FC<Props> = ({
  captained,
  classNameModifier = '',
}) => (
  <Icon
    id={!captained ? 'captain-unavailable' : 'captain'}
    size="s"
    className={getClassName(s, 'icon', classNames(classNameModifier, { noCaptain: !captained }))}
  />
);

export default CaptainIcon;
